var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "drivstoff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7309 4.43825L16.7409 4.42825L13.0209 0.708252L11.9609 1.76825L14.0709 3.87825C13.1309 4.23825 12.4609 5.13825 12.4609 6.20825C12.4609 7.58825 13.5809 8.70825 14.9609 8.70825C15.3209 8.70825 15.6509 8.62825 15.9609 8.49825V15.7083C15.9609 16.2583 15.5109 16.7083 14.9609 16.7083C14.4109 16.7083 13.9609 16.2583 13.9609 15.7083V11.2083C13.9609 10.1083 13.0609 9.20825 11.9609 9.20825H10.9609V2.20825C10.9609 1.10825 10.0609 0.208252 8.96094 0.208252H2.96094C1.86094 0.208252 0.960938 1.10825 0.960938 2.20825V18.2083H10.9609V10.7083H12.4609V15.7083C12.4609 17.0883 13.5809 18.2083 14.9609 18.2083C16.3409 18.2083 17.4609 17.0883 17.4609 15.7083V6.20825C17.4609 5.51825 17.1809 4.88825 16.7309 4.43825ZM8.96094 7.20825H2.96094V2.20825H8.96094V7.20825ZM14.9609 7.20825C14.4109 7.20825 13.9609 6.75825 13.9609 6.20825C13.9609 5.65825 14.4109 5.20825 14.9609 5.20825C15.5109 5.20825 15.9609 5.65825 15.9609 6.20825C15.9609 6.75825 15.5109 7.20825 14.9609 7.20825Z",
    fill: "#016CC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.49fe6740.svg";
export { ForwardRef as ReactComponent };